const retrieveKColorResponses = (responses, output, recursiveResponsesIndex) => {
  const kColorInputId = JSON.parse(output.calculation[0])['kcolor_question']
  // const surfaceQuestionId = JSON.parse(output.calculation[0])['surface_question']

  const value = recursiveResponsesIndex !== undefined ?
    responses[output.recursive_question_id]?.recursive_question_value[recursiveResponsesIndex]?.[kColorInputId]?.value :
    responses[kColorInputId]?.value
  if (!value)
    return {product: null, color: null, productPackage: null};

  const product = value.kColorProduct?.cod_prod_comm;
  const color = value.color?.code;
  const productPackage = value.productPackage;

  return {product, color, productPackage};
}
export default retrieveKColorResponses;